import { createRouter, createWebHistory } from 'vue-router';

// Use absolute paths starting from 'src'
import HomePage from '@/components/HomePage.vue';
import AuctionPage from '@/components/AuctionPage.vue';
import ItemPage from '@/components/ItemPage.vue';
import SalesPage from '@/components/SalesPage.vue';
import InventoryPage from '@/components/InventoryPage.vue';
import ExpensePage from '@/components/ExpensePage.vue';
import ReportsDashboard from '@/components/ReportsDashboard.vue';
import ProfitLossReport from '@/components/ProfitLossReport.vue';
import InventoryValueReport from '@/components/InventoryValueReport.vue';
import SalesAnalysisReport1 from '@/components/SalesAnalysisReport1.vue';
import RevenueByClassReport from '@/components/RevenueByClassReport.vue';
import BuyerReport from '@/components/BuyerReport.vue';
import PlatformPage from '@/components/PlatformPage.vue';
import LoginPage from '@/components/LoginPage.vue';
import FoodAdminPage from '@/components/FoodAdminPage.vue';
import CashControlPage from '@/components/CashControlPage.vue';
import AdminPage from '@/components/AdminPage.vue';

const routes = [
  { path: '/home', component: HomePage },
  { path: '/auctions', component: AuctionPage },
  { path: '/items', component: ItemPage },
  { path: '/sales', component: SalesPage },
  { path: '/inventory', component: InventoryPage },
  { path: '/expenses', component: ExpensePage },
  { path: '/reports-dashboard', component: ReportsDashboard },
  { path: '/reports/profit-loss', component: ProfitLossReport },
  { path: '/reports/inventory-value', component: InventoryValueReport },
  { path: '/reports/sales-analysis1', component: SalesAnalysisReport1 },
  { path: '/reports/revenue-by-class', component: RevenueByClassReport },
  { path: '/reports/buyer', component: BuyerReport },
  { path: '/food-admin', component: FoodAdminPage },
  { path: '/platforms', component: PlatformPage },
  { path: '/cash-control', component: CashControlPage },
  {
    path: '/admin',
    name: 'AdminPage',
    component: AdminPage,
    meta: {
      
      requiresAdmin: true
    }
  },
  { path: '/', component: LoginPage }
  
  
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// 🔥 Navigation Guard for Login + Admin Protection
router.beforeEach((to, from, next) => {
  const isAuthenticated = sessionStorage.getItem('authenticated') === 'true';

  let currentUser = null;

  try {
    currentUser = JSON.parse(sessionStorage.getItem('user') || 'null');
  } catch (error) {
    currentUser = null;
  }

  // Not logged in: only allow login/root page
  if (to.path !== '/' && !isAuthenticated) {
    next('/');
    return;
  }

  // Admin-only pages
  if (to.meta.requiresAdmin) {
    const isAdmin =
      currentUser?.role === 'admin' ||
      currentUser?.is_master_user === true;

    if (!isAdmin) {
      next('/home');
      return;
    }
  }

  next();
});

export default router;
